import React from "react";
import Highcharts from "highcharts";
import highMaps from "highcharts/modules/map";
import patternFill from "highcharts/modules/pattern-fill";
import HighchartsReact from "highcharts-react-official";
import mapData from "../../data/map";
import styleConstants from "../../styleConstants";

highMaps(Highcharts);
patternFill(Highcharts);

const Map = () => {
  const featureProperties = mapData.features.map(feature => feature.properties);

  const colorGroups = [
    "LIC",
    "LICND",
    "LMIC",
    "LMICND",
    "O",
    "UMIC",
    "UMICND",
    "UMICNI"
  ];

  const series = [
    {
      name: "World",
      color: "#fff",
      data: featureProperties.map(properties => ({
        iso_a3: properties.iso_a3
      })),
      showInLegend: false
    },
    ...colorGroups.map(colorGroup => {
      const color = styleConstants.categoryColors.mapColors[colorGroup];

      let pattern = styleConstants.categoryPatterns.mapPatterns[colorGroup];

      if (pattern) {
        pattern = {
          ...pattern,
          color
        };
      }

      return {
        name: colorGroup,
        color: !pattern
          ? styleConstants.categoryColors.mapColors[colorGroup]
          : { pattern },
        data: featureProperties
          .filter(properties => properties.color_grp === colorGroup)
          .map(properties => ({
            iso_a3: properties.iso_a3
          }))
      };
    })
  ];

  const options = {
    chart: {
      map: mapData
    },
    title: {
      text: "Map of Countries by GNI Group"
    },
    plotOptions: {
      map: {
        allAreas: false,
        joinBy: "iso_a3"
      }
    },
    subtitle: {
      text: null
    },
    series,
    legend: {
      enabled: false
    },
    tooltip: {
      backgroundColor: "white",
      useHTML: true,
      formatter: function() {
        if (this.series.name === "O") {
          return false;
        }

        let gniGroup;

        switch (this.series.name) {
          case "LMIC":
            gniGroup = "L-MIC";

            break;

          case "UMIC":
            gniGroup = "U-MIC";

            break;

          default:
            gniGroup = this.series.name;

            break;
        }

        let text = `${this.key}: ${gniGroup}`;

        if (this.series.name === "UMICNI") {
          text = `${this.key}: U-MIC<br />*not included in report`;
        } else if (this.series.name === "LICND") {
          text = `${this.key}: LIC<br />*no data available`;
        }

        return text;
      },
      style: {
        fontSize: "0.75rem",
        color: styleConstants.colors.gray6
      }
    },
    credits: {
      enabled: false
    }
  };

  return (
    <HighchartsReact
      options={options}
      constructorType="mapChart"
      highcharts={Highcharts}
    />
  );
};

export default Map;
